{
    "uploadBatchMetadata": "Upload Batch Metadata",
    "requiredFields": "Required Fields",
    "optionalFields": "Optional Fields",
    "deploymentFile": "Deployment File",
    "deploymentFileName": "Deployment File Name",
    "selectedFile": "Selected file",
    "invalidFileType": "Invalid file type. Please select a .zip file",
    "systemName": "System Name",
    "s3InputKey": "S3 Input Key",
    "emrClusterWorkers": "EMR Cluster Workers",
    "emrCoreInstanceType": "EMR Core Instance Type",
    "emrMasterInstanceType": "EMR Master Instance Type",
    "configHome": "Config Home",
    "dsHome": "DS Home",
    "s3InputBucket": "S3 Input Bucket",
    "s3OutputBucket": "S3 Output Bucket",
    "inputData": "Input Data",
    "dataSource": "Data Source",
    "unzipInput": "Unzip Input",
    "forceDeblocking": "Force Deblocking",
    "cleanupTempFiles": "Cleanup Temp Files",
    "requiresDepConversion": "Requires Dep Conversion",
    "default": "Default",
    "defaultFalse": "Default: False",
    "defaultTrue": "Default: True",
    "cancel": "Cancel",
    "uploading": "Uploading...",
    "uploadToS3": "Start Batch",
    "batchUpload": "Batch Upload",
    "pleaseFillRequired": "Please fill in all required fields",
    "uploadSuccessful": "Metadata uploaded successfully to {s3Key}",
    "uploadFailed": "Failed to upload metadata",
    "selectDatasourcePlaceholder": "Select datasource...",
    "selectDatasourceFirst": "Select a datasource to see available input files.",
    "noInputFilesForDatasource": "No input files are available for the selected datasource.",
    "selectedInputFile": "Selected input file",
    "refreshInputManifest": "Refresh input files",
    "uploadingBatchMetadata": "Submitting Batch",
    "batchUploadProgressMessage": "Submitting batch deployment to S3..."
}